import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import "../../assests/css/Dashboard.css";

class Sidebar extends Component {

  render() {

    const { sidebarOpen, handleLogout } = this.props;

    return (

      <div
        className={`dashboard-sidebar ${
          sidebarOpen ? "sidebar-open" : ""
        }`}
      >

        {/* LOGO */}
        <div className="sidebar-logo">
          <h3>🚗 Al Saad</h3>
          <span>RENT A CAR</span>
        </div>


        {/* MENU */}
        <div className="sidebar-menu">

          <p className="menu-title">
            MAIN MENU
          </p>


          {/* DASHBOARD */}
          <Link
            to="/dashboard"
            className="sidebar-link"
          >
            <span>📊</span>
            Dashboard
          </Link>


          {/* MY BOOKINGS */}
          <Link
            to="/my-bookings"
            className="sidebar-link"
          >
            <span>📅</span>
            My Bookings
          </Link>


          {/* TRIP REPORT */}
          <Link
            to="/TripReport"
            className="sidebar-link"
          >
            <span>📋</span>
            Trip Report
          </Link>


          {/* FAVOURITE CARS */}
          <Link
            to="/favourites"
            className="sidebar-link"
          >
            <span>❤️</span>
            Favourite Cars
          </Link>


          {/* ACCOUNT */}
          <p className="menu-title second-title">
            ACCOUNT
          </p>


          {/* PROFILE */}
          <Link
            to="/profile"
            className="sidebar-link"
          >
            <span>👤</span>
            My Profile
          </Link>


          {/* SUPPORT */}
          <Link
            to="/support"
            className="sidebar-link"
          >
            <span>📞</span>
            Support
          </Link>

        </div>


        {/* LOGOUT */}
        <div className="sidebar-bottom">

          <Button
            className="sidebar-logout-btn"
            onClick={handleLogout}
          >
            🚪 Logout
          </Button>

        </div>

      </div>

    );
  }
}

export default Sidebar;